import { AlertTriangle, CheckCircle2, CircleCheck, CircleX } from "lucide-react";

import { Textarea } from "@/components/ui/textarea";

import { reais } from "../lib/caixa";

const MOTIVOS = ["Troco dado errado", "Venda não lançada no sistema", "Sangria sem registro", "Cliente pagou em outra forma", "Erro na contagem"];

function Cabecalho({ r }) {
  if (r.resultado === "conferido") {
    // Bateu, mas com uma diferença pequena (dentro da diferença aceitável de Preferências → Caixa): mostra quanto
    const dif = Math.abs(r.diferenca) >= 0.01 ? r.diferenca : 0;
    return (
      <div className="rounded-2xl bg-emerald-500/10 border border-emerald-500/40 p-4 flex items-center gap-3" data-e2e="resultado-bateu">
        <CheckCircle2 className="w-9 h-9 text-emerald-600" />
        <div><p className="text-lg font-bold text-emerald-700 dark:text-emerald-400">
          Bateu! {dif ? `${dif < 0 ? "Faltaram" : "Sobraram"} ${reais(Math.abs(dif))}.` : ""} Pode fechar.</p>
          <p className="text-sm text-muted-foreground">
            {dif ? `Está dentro da diferença aceitável de até ${reais(r.tolerancia)} por forma (Preferências → Caixa).`
              : `Tudo dentro da diferença de até ${reais(r.tolerancia)} por forma.`}
          </p></div>
      </div>
    );
  }
  const falta = r.diferenca < 0;
  return (
    <div className="rounded-2xl bg-amber-500/10 border border-amber-500/40 p-4 flex items-center gap-3" data-e2e="resultado-diferenca">
      <AlertTriangle className="w-9 h-9 text-amber-600" />
      <div><p className="text-lg font-bold text-amber-700 dark:text-amber-400">Não bateu: {falta ? "faltam" : "sobram"} {reais(Math.abs(r.diferenca))}</p>
        <p className="text-sm text-muted-foreground">Reconte, ou explique o que aconteceu para fechar. Sobra também é sinal de erro (troco ou venda mal lançada).</p></div>
    </div>
  );
}

/** Passo 2 — esperado × contado por forma, e o motivo quando não bate. */
export default function PassoResultado({ f }) {
  const r = f.resultado;
  return (
    <div className="space-y-3">
      <Cabecalho r={r} />
      <div className="rounded-2xl border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-[11px] uppercase tracking-wider text-muted-foreground">
            <tr><th className="text-left px-3 py-2">Forma</th><th className="text-right px-2">Esperado</th><th className="text-right px-2">Contado</th><th className="text-right px-3">Diferença</th></tr>
          </thead>
          <tbody>
            {r.formas.map((x) => (
              <tr key={x.forma} className="border-t">
                <td className="px-3 py-2 font-medium">{x.forma}{(x.automatico || x.sem_forma) && <span className="ml-1.5 text-[10px] px-1.5 py-0.5 rounded bg-muted text-muted-foreground uppercase">{x.automatico ? "automático" : "sem forma"}</span>}</td>
                <td className="px-2 text-right tabular-nums">{reais(x.esperado)}</td>
                <td className="px-2 text-right tabular-nums">{reais(x.contado)}</td>
                <td className={`px-3 text-right tabular-nums font-semibold ${x.bateu ? "text-emerald-600" : "text-amber-600"}`}>
                  <span className="inline-flex items-center gap-1">{x.bateu ? <CircleCheck className="w-3.5 h-3.5" /> : <CircleX className="w-3.5 h-3.5" />}{x.diferenca > 0 ? "+" : ""}{reais(x.diferenca)}</span>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="border-t bg-muted/30 font-bold"><tr><td className="px-3 py-2">Total</td><td className="px-2 text-right tabular-nums">{reais(r.total_esperado)}</td><td className="px-2 text-right tabular-nums">{reais(r.total_contado)}</td><td className="px-3 text-right tabular-nums">{r.diferenca > 0 ? "+" : ""}{reais(r.diferenca)}</td></tr></tfoot>
        </table>
      </div>
      {r.resultado !== "conferido" && (
        <div>
          <label className="text-sm font-semibold">O que aconteceu? <span className="text-red-500">*</span></label>
          <div className="flex flex-wrap gap-1.5 my-2">
            {MOTIVOS.map((m) => <button key={m} type="button" onClick={() => f.setJustificativa(m)} className="text-xs px-2.5 py-1 rounded-full border hover:bg-muted">{m}</button>)}
          </div>
          <Textarea value={f.justificativa} onChange={(e) => f.setJustificativa(e.target.value)} rows={2} placeholder="Ex.: dei R$ 10 de troco a mais no pedido #1234" data-e2e="justificativa" />
          <p className="text-[11px] text-muted-foreground mt-1">Fica registrado no caixa, sai no cupom e vai no aviso de caixa fechado do dono.</p>
        </div>
      )}
    </div>
  );
}
